import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import AccountCircle from "@material-ui/icons/AccountCircle";
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import { Paper, Menu, MenuItem } from "@material-ui/core";
import { MdAccountCircle } from "react-icons/md";
import './AppBar.css'
import {useHistory} from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: "linear-gradient(to left, #5499C7 0%, #aec7f8 100%)",
    // backgroundColor:'pink',

    // height: '7vh'
  },
 
}));

export default function MenuAppBar(props) {
  const classes = useStyles();
  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory();


  // const handleChange = (event) => {
  //   setAuth(event.target.checked);
  // };
  function logout(){
    history.push('/');
  }

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar
          style={{
            // background: "linear-gradient(to left, #5499c7 0%, #6699ff 100%)",
            background: "linear-gradient(to left, #5499C7 0%, #aec7f8 100%)",
            // backgroundColor:'pink',
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              // backgroundColor:'red',
              height: "fit-content",
              marginLeft: "100vh",
              fontSize: "2.5vh",
              fontWeight: "bold",
              marginTop:'2.5vh'
            }}
          >
            {props.message}
          </p>
        
          {/* {auth && ( */}
          <div>
            <IconButton
            
              // aria-label="account of current user"
              // aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
              fontSize="large"
            >
              <AccountCircle />
            </IconButton>

            {/* <Paper> */}
            
          </div>

          
            <Menu
            className={'menu'}
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'bottom',
                horizontal: "right",
              }}
              open={open}
              onClose={handleClose}
            >
                {/* <div
                  style={{
                    backgroundColor: "purple",
                    width: "100%",
                    height: "30vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems:'center'
                  }}
                >
                  <MdAccountCircle
                    style={{ height: 280, width: 200, color: "#383838" }}
                  />
                </div> */}
              {/* </MenuItem> */}
              {/* <MenuItem
                // onClick={handleClose}
                style={{
                  width: "100%",
                  height: "7vh",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: "red",
                    width: "60%",
                    height: "7vh",
                    borderBottom: '0.3vh solid #383838',
                    color:'#383838',
                    display:'flex',
                    justifyContent:'center',
                    alignItems:'flex-end'
                  }}
                >
                  {props.email}

                </div>
              </MenuItem> */}

              <MenuItem
                onClick={logout}
                style={{
                  width: "100%",
                  height: "7vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems:'flex-end',
                  // backgroundColor:'pink'
                }}
              >
                <div className={'logoutDiv'} >
                    <p>LOGOUT</p>
                    </div>
              </MenuItem>
              
            </Menu>
          
        </Toolbar>
      </AppBar>
    </div>
  );
}
